import {COLLAPSE_CHAT, EXPAND_CHAT} from '../actions';

export default function collapsed(state = true, action) {
  switch (action.type) {
    case COLLAPSE_CHAT:
      return true;
    case EXPAND_CHAT:
      return false;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./chat-app/reducers/collapsed.js